import { loadGoogleMaps } from '../../utils/google-maps-loader';

const MAP_BLOCK_SAMPLE_DATA = {
	regions: [
		{
			id: 'east-central',
			name: 'East/Central',
			programmes: [
				{
					id: 'ec-thrive',
					title: 'Thrive Tennis',
					organisation: 'Thrive Foundation',
					regionName: 'East/Central',
					description: 'Community sessions designed to improve confidence and physical wellbeing for young adults.',
					link: '#',
					newTab: false,
					position: { lat: 52.2053, lng: 0.1218 }
				},
				{
					id: 'ec-open-courts',
					title: 'Open Courts Project',
					organisation: 'Open Courts',
					regionName: 'East/Central',
					description: 'Open access tennis sessions and volunteer-led support for underserved communities.',
					link: '#',
					newTab: false,
					position: { lat: 52.4862, lng: -1.8904 }
				}
			]
		},
		{
			id: 'north-midlands-east',
			name: 'North and Midlands East',
			programmes: [
				{
					id: 'nme-rally',
					title: 'Rally Together',
					organisation: 'Rally Together CIC',
					regionName: 'North and Midlands East',
					description: 'After-school tennis and mentoring sessions for children and families.',
					link: '#',
					newTab: false,
					position: { lat: 53.8008, lng: -1.5491 }
				}
			]
		},
		{
			id: 'north-midlands-west',
			name: 'North and Midlands West',
			programmes: [
				{
					id: 'nmw-serve',
					title: 'Serve and Support',
					organisation: 'Serve and Support UK',
					regionName: 'North and Midlands West',
					description: 'Inclusive group tennis programmes with mental wellbeing workshops.',
					link: '#',
					newTab: false,
					position: { lat: 53.4084, lng: -2.9916 }
				}
			]
		},
		{
			id: 'south-south-west',
			name: 'South and South West',
			programmes: [
				{
					id: 'ssw-tennis-connect',
					title: 'Tennis Connect',
					organisation: 'Tennis Connect',
					regionName: 'South and South West',
					description: 'Accessible tennis sessions in parks, helping isolated adults reconnect through sport.',
					link: '#',
					newTab: false,
					position: { lat: 50.8225, lng: -0.1372 }
				}
			]
		},
		{
			id: 'london',
			name: 'London',
			programmes: [
				{
					id: 'london-acez',
					title: 'Tennis Talk',
					organisation: 'Access Sport - Acez Tennis',
					regionName: 'London',
					description:
						'Tennis Talk uses tennis to combat poor mental health, combining sport with talking therapy to stimulate conversation and reduce stigma.',
					link: '#',
					newTab: false,
					position: { lat: 51.5142, lng: -0.09 }
				},
				{
					id: 'london-racketts-cubed',
					title: 'Racketts Cubed',
					organisation: 'Racketts Cubed',
					regionName: 'London',
					description: 'Free youth sessions combining tennis and life-skills development in local communities.',
					link: '#',
					newTab: false,
					position: { lat: 51.537, lng: -0.1215 }
				},
				{
					id: 'london-greenhouse',
					title: 'Greenhouse Sports – Gamechangers',
					organisation: 'Greenhouse Sports',
					regionName: 'London',
					description: 'Coach-led tennis and mentoring for young people facing barriers to participation.',
					link: '#',
					newTab: false,
					position: { lat: 51.4952, lng: -0.1113 }
				},
				{
					id: 'london-give-it-your-max',
					title: 'Give it Your Max',
					organisation: 'Give it Your Max',
					regionName: 'London',
					description: 'Tennis programmes that build confidence, resilience and pathways into coaching.',
					link: '#',
					newTab: false,
					position: { lat: 51.5058, lng: -0.1419 }
				}
			]
		},
		{
			id: 'south-east',
			name: 'South East',
			programmes: [
				{
					id: 'se-baseline',
					title: 'Baseline Futures',
					organisation: 'Baseline Futures',
					regionName: 'South East',
					description: 'Weekly tennis and mentoring support for teenagers in local hubs.',
					link: '#',
					newTab: false,
					position: { lat: 51.4545, lng: -0.9781 }
				}
			]
		},
		{
			id: 'scotland',
			name: 'Scotland',
			programmes: [
				{
					id: 'scotland-smash',
					title: 'Smash Scotland',
					organisation: 'Smash Scotland',
					regionName: 'Scotland',
					description: 'Community tennis for all ages, with dedicated disability-inclusive sessions.',
					link: '',
					newTab: false,
					position: { lat: 55.9533, lng: -3.1883 }
				}
			]
		},
		{
			id: 'wales',
			name: 'Wales',
			programmes: [
				{
					id: 'wales-open-play',
					title: 'Open Play Wales',
					organisation: 'Open Play Wales',
					regionName: 'Wales',
					description: 'Local tennis sessions and social activity designed for wellbeing and inclusion.',
					link: '#',
					newTab: true,
					position: { lat: 51.4816, lng: -3.1791 }
				}
			]
		}
	],
	title: 'The sidebar title goes here'
};

const MAP_BLOCK_STYLES = [
	{
		featureType: 'administrative',
		elementType: 'geometry',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'administrative.land_parcel',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'administrative.neighborhood',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'landscape',
		elementType: 'geometry.fill',
		stylers: [{ color: '#eff8f0' }]
	},
	{
		featureType: 'poi',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'poi',
		elementType: 'labels.text',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'road',
		elementType: 'geometry.fill',
		stylers: [{ color: '#cdd4d8' }]
	},
	{
		featureType: 'road',
		elementType: 'labels',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'road',
		elementType: 'labels.icon',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'road',
		elementType: 'labels.text.fill',
		stylers: [{ color: '#2d343c' }]
	},
	{
		featureType: 'road',
		elementType: 'labels.text.stroke',
		stylers: [{ color: '#ffffff' }]
	},
	{
		featureType: 'road.arterial',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'road.highway',
		elementType: 'labels',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'road.local',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'transit',
		stylers: [{ visibility: 'off' }]
	},
	{
		featureType: 'water',
		elementType: 'geometry.fill',
		stylers: [{ color: '#16316f' }]
	},
	{
		featureType: 'water',
		elementType: 'labels.text',
		stylers: [{ visibility: 'off' }]
	}
];

const MAP_BLOCK_MARKER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><g clip-path="url(#clip0_5206_14834)"><path d="M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z" fill="white"/><path d="M4.45312 39.25C8.96817 45.7472 16.4857 50.0009 24.9973 50.0009C28.7758 50.0009 32.3588 49.1625 35.5697 47.662L4.45312 39.25Z" fill="#DA306C"/><path d="M39.3514 45.4727C45.791 40.95 50 33.4672 50 25.0005C50 17.5139 46.7088 10.7963 41.4949 6.21484L5.46862 9.39447C2.04666 13.6718 0 19.0968 0 25.0005C0 28.732 0.817746 32.2723 2.28345 35.4523L39.3514 45.4727Z" fill="#DA306C"/><path d="M37.6882 3.45463C33.9689 1.25972 29.6319 0 25.0007 0C18.7924 0 13.1131 2.26343 8.74219 6.00926L37.6882 3.45417V3.45463Z" fill="#DA306C"/></g><defs><clipPath id="clip0_5206_14834"><rect width="50" height="50" fill="white"/></clipPath></defs></svg>`;
const MAP_BLOCK_MARKER_ICON_URL = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(MAP_BLOCK_MARKER_SVG)}`;

const createMapBlockMarkerIcon = (size = 50) => ({
	url: MAP_BLOCK_MARKER_ICON_URL,
	scaledSize: new window.google.maps.Size(size, size),
	anchor: new window.google.maps.Point(size / 2, size / 2),
	labelOrigin: new window.google.maps.Point(size / 2, size / 2)
});

const escapeHTML = (value = '') => {
	const map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#39;'
	};

	return String(value).replace(/["&'<>]/g, (character) => map[character]);
};

const isMapBlockDebugEnabled = () => {
	try {
		return Boolean(window.LTA_DEBUG_MAP_BLOCK) || window.localStorage.getItem('lta:debug:map-block') === '1';
	} catch {
		return false;
	}
};

const logMapBlockDebug = (message, details) => {
	if (!isMapBlockDebugEnabled()) {
		return;
	}

	if (window.console && typeof window.console.info === 'function') {
		if (details !== undefined) {
			window.console.info(`[MapBlock] ${message}`, details);
			return;
		}

		window.console.info(`[MapBlock] ${message}`);
	}
};

const getMapBlockSampleData = async () => {
	await new Promise((resolve) => setTimeout(resolve, 120));
	if (window.console && typeof window.console.info === 'function') {
		window.console.info('[MapBlock] Data source: sample-data (dev-main)');
	}

	return MAP_BLOCK_SAMPLE_DATA;
};

const fetchMapBlockDataFromApi = async (endpoint) => {
	const response = await fetch(endpoint, {
		headers: {
			Accept: 'application/json'
		}
	});

	if (!response.ok) {
		throw new Error(`Map block request failed with status ${response.status}`);
	}

	if (window.console && typeof window.console.info === 'function') {
		window.console.info('[MapBlock] Data source: api', { endpoint });
	}

	return response.json();
};

const fetchMapBlockData = async (element) => {
	const endpoint = element.getAttribute('data-map-endpoint');
	const isInDevelopmentMain = Boolean(element.closest('.dev-main'));
	const hasRealEndpoint = Boolean(endpoint) && endpoint !== '/map-endpoint-here';
	const shouldUseSampleData = isInDevelopmentMain && !hasRealEndpoint;

	logMapBlockDebug('Fetching map block data', {
		mode: shouldUseSampleData ? 'sample-data' : 'api',
		endpoint: endpoint || undefined
	});

	if (shouldUseSampleData) {
		return getMapBlockSampleData();
	}

	if (!endpoint) {
		throw new Error('Map block endpoint is missing');
	}

	try {
		return await fetchMapBlockDataFromApi(endpoint);
	} catch (error) {
		if (isInDevelopmentMain) {
			if (window.console && typeof window.console.warn === 'function') {
				window.console.warn('[MapBlock] API unavailable in dev, falling back to sample-data', {
					endpoint,
					error: error && error.message ? error.message : 'Unknown error'
				});
			}

			return getMapBlockSampleData();
		}

		throw error;
	}
};

const waitForGoogleMapsApi = (timeoutMs = 10 * 1000, pollIntervalMs = 12 * 10) =>
	new Promise((resolve) => {
		if (window.google && window.google.maps) {
			logMapBlockDebug('Google Maps API already available at init start');
			resolve(true);
			return;
		}

		const startedAt = Date.now();
		const intervalId = window.setInterval(() => {
			if (window.google && window.google.maps) {
				window.clearInterval(intervalId);
				logMapBlockDebug('Google Maps API became available', {
					waitedMs: Date.now() - startedAt
				});
				resolve(true);
				return;
			}

			if (Date.now() - startedAt >= timeoutMs) {
				window.clearInterval(intervalId);
				if (window.console && typeof window.console.warn === 'function') {
					window.console.warn('[MapBlock] Google Maps API was not available before timeout', {
						timeoutMs,
						hasGoogle: Boolean(window.google),
						hasMaps: Boolean(window.google && window.google.maps)
					});
				}
				resolve(false);
			}
		}, pollIntervalMs);
	});

class MapBlockDemo {
	getAllProgrammes() {
		if (!this.data || !Array.isArray(this.data.regions)) {
			return [];
		}
		// Flatten all programmes from all regions, adding regionId and regionName
		return this.data.regions.flatMap((region) =>
			region.programmes.map((programme) => ({
				...programme,
				regionId: region.id,
				regionName: region.name
			}))
		);
	}
	constructor(element) {
		this.element = element;
		this.sidebar = element.querySelector('.js-map-block-sidebar');
		this.sidebarHeader = element.querySelector('.js-map-block-sidebar-header');
		this.sidebarContent = element.querySelector('.js-map-block-sidebar-content');
		this.sidebarContent.setAttribute('tabindex', '-1');
		this.mapElement = element.querySelector('.js-map-block-map');
		this.collapseButton = element.querySelector('.js-map-block-collapse');
		this.data = undefined;
		this.currentRegion = undefined;
		this.selectedProgrammeId = undefined;
		this.markersByProgrammeId = new Map();
		this.programmesById = new Map();
		this.clusterMarkers = [];
		this.clusterZoomThreshold = 7;
		this.map = undefined;
		this.infoWindow = undefined;
		this.lastZoom = undefined;
		this.shouldResetToAllOnZoomOut = false;
	}

	async init() {
		// The Maps JavaScript API is no longer loaded globally; request it on
		// demand, then reuse the existing readiness poll and its fallbacks
		loadGoogleMaps().catch(() => {});
		const isGoogleMapsReady = await waitForGoogleMapsApi();
		if (!isGoogleMapsReady) {
			if (window.console && typeof window.console.warn === 'function') {
				window.console.warn('[MapBlock] Initialization aborted because Google Maps API is unavailable');
			}
			return;
		}

		logMapBlockDebug('MapBlock initialization continuing after Google Maps readiness check');

		try {
			this.data = await fetchMapBlockData(this.element);
		} catch {
			this.data = { regions: [] };
		}

		if (!this.data || !Array.isArray(this.data.regions)) {
			this.data = { regions: [] };
		}

		this.currentRegion = undefined;
		this.selectedProgrammeId = undefined;
		this.setInitialSidebarState();

		this.initializeMap();
		this.renderRegionList();
		this.renderMarkers();
		this.bindEvents();
		this.updateMarkerAndClusterState();
		this.setInitialViewport();
	}

	setInitialSidebarState() {
		this.setSidebarCollapsedState(true);

		if (!window.matchMedia('(min-width: 768px)').matches) {
			return;
		}

		window.requestAnimationFrame(() => {
			this.setSidebarCollapsedState(false);
		});
	}

	setSidebarCollapsedState(isCollapsed) {
		const wasCollapsed = this.element.classList.contains('is-collapsed');
		this.element.classList.toggle('is-collapsed', isCollapsed);
		this.collapseButton.setAttribute('aria-expanded', String(!isCollapsed));
		this.collapseButton.setAttribute('aria-label', isCollapsed ? 'Expand map sidebar' : 'Collapse map sidebar');

		if (!this.map || wasCollapsed === isCollapsed) {
			return;
		}

		const currentZoom = this.map.getZoom();
		const currentCenter = this.map.getCenter();

		window.setTimeout(() => {
			window.google.maps.event.trigger(this.map, 'resize');
			if (currentCenter) {
				this.map.setCenter(currentCenter);
			}

			if (currentZoom !== undefined && currentZoom !== null) {
				this.map.setZoom(currentZoom);
			}
		}, 260);
	}

	initializeMap() {
		this.map = new window.google.maps.Map(this.mapElement, {
			center: { lat: 54.5, lng: -2.4 },
			zoom: 6,
			styles: MAP_BLOCK_STYLES,
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false
		});

		this.lastZoom = this.map.getZoom();

		this.infoWindow = new window.google.maps.InfoWindow({
			maxWidth: 360,
			disableAutoPan: true,
			pixelOffset: new window.google.maps.Size(0, -12)
		});

		this.map.addListener('click', () => {
			this.infoWindow.close();
		});

		this.map.addListener('zoom_changed', () => {
			this.updateMarkerAndClusterState();
		});
		this.map.addListener('idle', () => {
			this.updateSidebarRegionsOnZoom();
		});
	}

	getVisibleProgrammes() {
		if (!this.currentRegion) {
			return this.getAllProgrammes();
		}

		const region = this.data.regions.find((entry) => entry.id === this.currentRegion);
		if (!region) {
			return [];
		}

		return region.programmes.map((programme) => ({
			...programme,
			regionId: region.id,
			regionName: region.name
		}));
	}

	renderMarkers() {
		const normalIcon = createMapBlockMarkerIcon(38);
		const activeIcon = createMapBlockMarkerIcon(46);

		for (const programme of this.getAllProgrammes()) {
			const marker = new window.google.maps.Marker({
				position: programme.position,
				map: this.map,
				icon: normalIcon,
				label: undefined,
				title: programme.title,
				optimized: false
			});

			marker.addListener('click', () => {
				this.setSelectedProgramme(programme.id, true);
			});

			marker._normalIcon = normalIcon;
			marker._activeIcon = activeIcon;
			this.markersByProgrammeId.set(programme.id, marker);
			this.programmesById.set(programme.id, programme);
		}
	}

	clearClusterMarkers() {
		for (const marker of this.clusterMarkers) {
			marker.setVisible(false);
		}

		this.clusterMarkers = [];
	}

	buildClusters(programmes) {
		const zoom = this.map.getZoom() || this.clusterZoomThreshold;
		const clusterRadius = 70;
		const scale = 256 * 2 ** zoom;

		const toPixel = ({ lat, lng }) => {
			const sinLatitude = Math.sin((lat * Math.PI) / 180);
			const clampedSinLatitude = Math.min(Math.max(sinLatitude, -0.9999), 0.9999);

			return {
				x: ((lng + 180) / 360) * scale,
				y: (0.5 - Math.log((1 + clampedSinLatitude) / (1 - clampedSinLatitude)) / (4 * Math.PI)) * scale
			};
		};

		const clusters = [];

		for (const programme of programmes) {
			const point = toPixel(programme.position);
			let matchedCluster;

			for (const cluster of clusters) {
				const deltaX = point.x - cluster.center.x;
				const deltaY = point.y - cluster.center.y;
				if (Math.hypot(deltaX, deltaY) <= clusterRadius) {
					matchedCluster = cluster;
					break;
				}
			}

			if (!matchedCluster) {
				clusters.push({
					programmes: [programme],
					sumX: point.x,
					sumY: point.y,
					center: point
				});
				continue;
			}

			matchedCluster.programmes.push(programme);
			matchedCluster.sumX += point.x;
			matchedCluster.sumY += point.y;
			matchedCluster.center = {
				x: matchedCluster.sumX / matchedCluster.programmes.length,
				y: matchedCluster.sumY / matchedCluster.programmes.length
			};
		}

		return clusters.map((cluster) => cluster.programmes);
	}

	updateMarkerAndClusterState() {
		// Always show all markers, no clustering or hiding
		for (const marker of this.markersByProgrammeId.values()) {
			marker.setVisible(true);
		}
		this.clearClusterMarkers();
	}

	updateSidebarRegionsOnZoom() {
		const bounds = this.map.getBounds();
		if (!bounds) return;
		const visibleRegionIds = this._getVisibleRegionIds(bounds);
		if (this.currentRegion) {
			this._maybeSwitchToRegionView(visibleRegionIds);
			return;
		}
		this._renderSidebarRegionList(visibleRegionIds);
	}

	_getVisibleRegionIds(bounds) {
		const visibleRegionIds = new Set();
		for (const [programmeId, marker] of this.markersByProgrammeId.entries()) {
			if (marker.getVisible() && bounds.contains(marker.getPosition())) {
				const programme = this.programmesById.get(programmeId);
				if (programme) visibleRegionIds.add(programme.regionId);
			}
		}
		return visibleRegionIds;
	}

	_maybeSwitchToRegionView(visibleRegionIds) {
		if (visibleRegionIds.size > 1 && !this.infoWindow.getMap() && this.shouldResetToAllOnZoomOut) {
			this.currentRegion = undefined;
			this.selectedProgrammeId = undefined;
			// Only show regions that have at least one marker actually visible in the map bounds
			const bounds = this.map.getBounds();
			const visibleRegionIdsStrict = new Set();
			for (const [programmeId, marker] of this.markersByProgrammeId.entries()) {
				if (marker.getVisible() && bounds.contains(marker.getPosition())) {
					const programme = this.programmesById.get(programmeId);
					if (programme) visibleRegionIdsStrict.add(programme.regionId);
				}
			}
			// Show the sidebar header when switching back to region list
			this.sidebarHeader.hidden = false;
			this.sidebarHeader.textContent = this.data.title;
			this._renderSidebarRegionList(visibleRegionIdsStrict);
			this.updateMarkerVisibility();
			this.syncMarkerSelectionUI();
			// Do NOT fit to visible markers here, so the map doesn't zoom out and show all regions
			this.shouldResetToAllOnZoomOut = false;
		}
	}

	_renderSidebarRegionList(visibleRegionIds) {
		this.sidebarContent.innerHTML = this.data.regions
			.filter((region) => visibleRegionIds.has(region.id))
			.map(
				(region) => `
					<button type="button" class="map-block__region-item" data-region-id="${escapeHTML(region.id)}">
						<span>${escapeHTML(region.name)}</span>
						<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
							<path d="M7.45946 10L0 2.33333L2.27027 0L12 10L2.27027 20L0 17.6667L7.45946 10Z" fill="currentColor"></path>
						</svg>
					</button>
				`
			)
			.join('');
	}

	renderRegionList() {
		this.sidebarHeader.hidden = false;
		this.sidebarHeader.textContent = this.data.title;
		this.sidebarContent.innerHTML = this.data.regions
			.map(
				(region) => `
					<button type="button" class="map-block__region-item" data-region-id="${escapeHTML(region.id)}">
						<span>${escapeHTML(region.name)}</span>
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
              <path d="M7.45946 10L0 2.33333L2.27027 0L12 10L2.27027 20L0 17.6667L7.45946 10Z" fill="currentColor"></path>
            </svg>
					</button>
				`
			)
			.join('');
	}

	renderProgrammesForRegion(regionId, fromRegionSelection = false) {
		const region = this.data.regions.find((entry) => entry.id === regionId);
		if (!region) {
			return;
		}

		this.currentRegion = region.id;
		this.sidebarHeader.hidden = true;
		this.sidebarHeader.innerHTML = '';
		this.sidebarContent.innerHTML = `
			<div class="map-block__programme-header">
				<h2 class="map-block__programme-title">${region.programmes.length} ${escapeHTML(region.name)} programmes</h2>
				<button type="button" class="map-block__back-link js-map-block-back">
					<svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none" aria-hidden="true" focusable="false">
						<path d="M2.79844 6L7.39844 10.6L5.99844 12L-0.0015626 6L5.99844 0L7.39844 1.4L2.79844 6Z" fill="currentColor"/>
					</svg>
					<span>Back to region list</span>
				</button>
			</div>
			${region.programmes
				.map(
					(programme) => `
						<button type="button" class="map-block__programme-item" data-programme-id="${escapeHTML(programme.id)}">
							<span class="map-block__programme-ball" aria-hidden="true"></span>
							<span class="map-block__programme-copy">
								<span>${escapeHTML(programme.organisation)}</span>
								<span class="map-block__programme-copy-title">${escapeHTML(programme.title)}</span>
							</span>
						</button>
					`
				)
				.join('')}
		`;

		this.updateMarkerVisibility();
		this.fitToVisibleMarkers();

		if (fromRegionSelection && region.programmes.length === 1) {
			window.google.maps.event.addListenerOnce(this.map, 'idle', () => {
				this.map.setZoom(12);
			});
		}
	}

	updateMarkerVisibility() {
		this.updateMarkerAndClusterState();
	}

	adjustZoomBy(levels) {
		const currentZoom = this.map.getZoom();
		if (currentZoom === undefined || currentZoom === null) {
			return;
		}

		const nextZoom = Math.max(0, currentZoom + levels);
		this.map.setZoom(nextZoom);
	}

	setInitialViewport() {
		const ukBounds = new window.google.maps.LatLngBounds({ lat: 49.5, lng: -8.7 }, { lat: 59.1, lng: 2.1 });

		this.map.fitBounds(ukBounds, 40);
		window.google.maps.event.addListenerOnce(this.map, 'idle', () => {
			this.adjustZoomBy(1);
		});
	}

	fitToVisibleMarkers() {
		const visibleProgrammes = this.getVisibleProgrammes();
		if (visibleProgrammes.length === 0) {
			return;
		}

		const bounds = new window.google.maps.LatLngBounds();

		for (const programme of visibleProgrammes) {
			bounds.extend(programme.position);
		}

		this.map.fitBounds(bounds, 60);
	}

	setSelectedProgramme(programmeId, fromMarker = false) {
		const programme = this.getAllProgrammes().find((entry) => entry.id === programmeId);
		if (!programme) {
			return;
		}

		this.shouldResetToAllOnZoomOut = false;

		const marker = this.markersByProgrammeId.get(programmeId);

		const hasRegionChanged = this.currentRegion !== programme.regionId;

		if (hasRegionChanged) {
			this.renderProgrammesForRegion(programme.regionId);
		}

		this.selectedProgrammeId = programmeId;
		this.syncProgrammeSelectionUI();
		this.syncMarkerSelectionUI();
		this.openInfoWindow(programmeId);

		if (!fromMarker && marker) {
			if ((this.map.getZoom() || 0) <= this.clusterZoomThreshold) {
				this.map.setZoom(this.clusterZoomThreshold + 1);
			}

			this.map.panTo(marker.getPosition());
		}

		if (fromMarker && marker) {
			this.map.setZoom(12);
			this.map.panTo(marker.getPosition());
		}

		if (fromMarker) {
			window.google.maps.event.addListenerOnce(this.infoWindow, 'domready', () => {
				const popupElement = document.querySelector('.map-block__info-window');
				if (!popupElement) return;

				// Walk up to the Google Maps InfoWindow container (gm-style-iw-d or gm-style-iw)
				const iwContainer = popupElement.closest('.gm-style-iw') || popupElement.parentElement;
				const popupHeight = iwContainer ? iwContainer.offsetHeight : popupElement.offsetHeight;
				const markerHeight = 46; // active marker icon size in px
				const totalOffset = popupHeight + markerHeight;

				// Pan up by half the total offset so the popup is vertically centred in the map
				this.map.panBy(0, -Math.round(totalOffset / 2));
			});
		}
	}

	syncProgrammeSelectionUI() {
		for (const element of this.sidebarContent.querySelectorAll('[data-programme-id]')) {
			const isActive = element.getAttribute('data-programme-id') === this.selectedProgrammeId;
			element.classList.toggle('is-active', isActive);
		}
	}

	syncMarkerSelectionUI() {
		for (const [programmeId, marker] of this.markersByProgrammeId.entries()) {
			marker.setIcon(programmeId === this.selectedProgrammeId ? marker._activeIcon : marker._normalIcon);
		}

		this.updateMarkerAndClusterState();
	}

	openInfoWindow(programmeId) {
		const programme = this.getAllProgrammes().find((entry) => entry.id === programmeId);
		const marker = this.markersByProgrammeId.get(programmeId);

		if (!programme || !marker) {
			return;
		}

		const popupTitleId = `map-block-popup-title-${programme.id}`;
		const linkUrl = typeof programme.link === 'string' ? programme.link.trim() : '';
		const hasCtaLink = linkUrl.length > 0;
		const shouldOpenInNewTab = hasCtaLink && (programme.newTab === true || programme.newTab === 'true');
		const linkTargetAttributes = shouldOpenInNewTab ? ' target="_blank" rel="noopener noreferrer"' : '';
		let ctaMarkup = '';
		if (hasCtaLink) {
			ctaMarkup = `<a class="map-block__info-cta lta-btn lta-btn--lg lta-btn--inverse" href="${escapeHTML(
				linkUrl
			)}"${linkTargetAttributes}>Learn more <span class="sr-only">about ${escapeHTML(programme.title)}</span></a>`;
		}

		this.infoWindow.setContent(`
			<div class="map-block__info-window" role="dialog" aria-labelledby="${escapeHTML(popupTitleId)}">
				<div class="map-block__info-top">
					<h3 id="${escapeHTML(popupTitleId)}" class="map-block__info-title">${escapeHTML(programme.organisation)}</h3>
					<button type="button" class="map-block__info-close js-map-block-close-modal" aria-label="Close map programme modal">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
							<rect x="18.0078" y="15.8896" width="3" height="14" transform="rotate(135 18.0078 15.8896)" fill="#16316F"></rect>
							<rect x="15.8906" y="5.99023" width="3" height="14" transform="rotate(45 15.8906 5.99023)" fill="#16316F"></rect>
						</svg>
					</button>
				</div>
				<p class="map-block__info-org">${escapeHTML(programme.title)}</p>
				<p class="map-block__info-description">${escapeHTML(programme.description)}</p>
				${ctaMarkup}
			</div>
		`);

		this.infoWindow.open({ anchor: marker, map: this.map, shouldFocus: false });

		if (window.matchMedia('(max-width: 767px)').matches && !this.element.classList.contains('is-collapsed')) {
			this.collapseButton.click();
			// focus on the popup
		}

		window.google.maps.event.addListenerOnce(this.infoWindow, 'domready', () => {
			const closeButton = document.querySelector('.js-map-block-close-modal');
			if (closeButton) {
				closeButton.addEventListener('click', (event) => {
					event.preventDefault();
					this.closeInfoWindowAndEnableResetOnZoomOut();
				});

				closeButton.focus({ preventScroll: true });
				return;
			}

			const popup = document.querySelector('.map-block__info-window');
			if (popup) {
				popup.setAttribute('tabindex', '-1');
				popup.focus({ preventScroll: true });
			}
		});
	}

	closeInfoWindowAndEnableResetOnZoomOut() {
		const hasActiveSelection = Boolean(this.selectedProgrammeId);
		this.infoWindow.close();

		if (hasActiveSelection) {
			this.shouldResetToAllOnZoomOut = true;
		}
	}

	bindEvents() {
		const mobileSidebarMediaQuery = window.matchMedia('(max-width: 767px)');
		const updateSidebarForViewport = (event) => {
			this.setSidebarCollapsedState(event.matches);
		};

		if (typeof mobileSidebarMediaQuery.addEventListener === 'function') {
			mobileSidebarMediaQuery.addEventListener('change', updateSidebarForViewport);
		} else if (typeof mobileSidebarMediaQuery.addListener === 'function') {
			mobileSidebarMediaQuery.addListener(updateSidebarForViewport);
		}

		this.sidebarContent.addEventListener('click', (event) => {
			const regionButton = event.target.closest('[data-region-id]');
			if (regionButton) {
				event.preventDefault();
				this.renderProgrammesForRegion(regionButton.getAttribute('data-region-id'), true);
				this.sidebarContent.focus({ preventScroll: true });
				return;
			}

			const programmeButton = event.target.closest('[data-programme-id]');
			if (programmeButton) {
				event.preventDefault();
				const programmeId = programmeButton.getAttribute('data-programme-id');
				this.setSelectedProgramme(programmeId, true);

				const marker = this.markersByProgrammeId.get(programmeId);
				if (marker) {
					this.map.panTo(marker.getPosition());
				}
				return;
			}

			if (event.target.closest('.js-map-block-back')) {
				event.preventDefault();
				this.currentRegion = undefined;
				this.selectedProgrammeId = undefined;
				this.infoWindow.close();
				this.renderRegionList();
				this.updateMarkerVisibility();
				this.syncMarkerSelectionUI();
				this.fitToVisibleMarkers();
				this.sidebarContent.focus({ preventScroll: true });
			}
		});

		this.collapseButton.addEventListener('click', () => {
			const shouldCollapse = !this.element.classList.contains('is-collapsed');
			this.setSidebarCollapsedState(shouldCollapse);
		});
	}
}

// End of MapBlockDemo class

const setInitialMapBlockHeight = (element) => {
	// Find the layout container
	const layout = element.querySelector('.map-block__layout');
	if (!layout) return;
	// Set initial height
	const initialHeight = layout.offsetHeight;
	layout.style.height = initialHeight + 'px';

	// Update height on window resize
	const onResize = () => {
		// Optionally, you can recalculate or keep the original height
		// Here, we keep the original height unless the window shrinks
		const minHeight = Math.max(initialHeight, 480); // fallback min
		layout.style.height = minHeight + 'px';
	};
	window.addEventListener('resize', onResize);
};

const initMapBlockDemo = () => {
	for (const element of document.querySelectorAll('.js-map-block')) {
		if (element.dataset.mapBlockInitialized === 'true') {
			continue;
		}

		element.dataset.mapBlockInitialized = 'true';
		setInitialMapBlockHeight(element);
		const mapBlock = new MapBlockDemo(element);
		mapBlock.init();
	}
};

export default initMapBlockDemo;
